import { BaseApiResponse } from '@api/types';

export enum WarrantyBrand {
  Honda = 'Honda',
  Cramer = 'Cramer',
  Tielburger = 'Tielburger',
  EPower = 'E-Power',
  Biemmedue = 'Biemmedue',
  Mammotion = 'Mammotion',
  ShizuokaSeiki = 'Shizuoka Seiki',
  Others = 'Others',
}

export enum WarrantyPurchase {
  Private = 'Private',
  Company = 'Company',
}

export enum WarrantyClaimStatus {
  Draft = 'Draft',
  New = 'New',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Returned = 'Returned',
  SentToVendor = 'SentToVendor',
  Credited = 'Credited',
  SentToVendorAndCredited = 'SentToVendorAndCredited',
}

export enum WarrantyClaimType {
  Warranty = 'Warranty',
  Complaint = 'Complaint',
  Goodwill = 'Goodwill',
}

export type WarrantyServiceType = 'labor' | 'troubleshooting' | 'diverse' | 'freight';

export type WarrantyPart = {
  id?: number | string;
  index?: number;
  designation?: string;
  quantity: number;
  totalPrice?: number;
  price?: number;
  partNo?: string;
  maxQuantity?: number;
};

export type WarrantyWork = {
  id?: number;
  serviceTypes?: WarrantyServiceType;
  price?: number;
  quantity?: number;
  totalPrice?: number;
  partNo?: string;
};

export interface Warranty {
  brand: WarrantyBrand;
  customerAddress?: string;
  customerName?: string;
  customerPostCode?: string;
  customerCity?: string;
  dealerContact?: string;
  dealerEmail?: string;
  dealerName?: string;
  defectCode?: string | null;
  destinationCode?: string | null;
  id?: number;
  issueDescription?: string | null;
  moreInformation?: string;
  organizationId?: string;
  parts?: WarrantyPart[] | null;
  works?: WarrantyWork[] | null;
  possibleErrorCauses?: string | null;
  productModel?: string;
  productType?: string;
  purchase?: WarrantyPurchase;
  recipeFile?: any | null;
  saleDate?: string;
  serialNo?: string;
  status?: WarrantyClaimStatus;
  symptomCode?: string | null;
  damageDate?: string;
  createdDate?: string;
  engineNo?: string;
  repairDate?: string;
  hoursOfWork?: string;
  partCouseError?: string;
  orderId?: string;
  productName?: string;
  machineNo?: string;
  dealerOrderId?: string;
  city?: string;
  dealerId?: string;
  deliveredAndTested?: string | null;
  engineNumber?: string | null;
  howItWorksInstructions?: string | null;
  manualDelivered?: string | null;
  postCode?: string;
  contact?: string;
  claimType?: WarrantyClaimType;
  comment?: string;
  internalComment?: string;
  partsDiscount?: number;
  laborPrice?: number;
  troubleshootingPrice?: number;
  isNewForBerema?: boolean;
  isNewForDealer?: boolean;
  customerNo?: string;
  invoiceNo?: string;
  reviewedBy?: string;
}

export type WarrantyListResponse = BaseApiResponse<{
  items: Warranty[];
  totalCount: number;
  next: number;
}>;
export type WarrantyListRequest = {
  paging: {
    skip: number;
    take: number;
  };
};

export type WarrantyVerifySerialNumberRequest = {
  serialNumber: string;
  id: string;
};

export type WarrantyVerifySerialNumberResponse = BaseApiResponse<{
  isClaimed?: boolean;
}>;

export type WarrantyDetailsResponse = BaseApiResponse<Warranty>;

export type WarrantyCreateFormResponse = number;
export type WarrantyCreateFromRequest = Omit<Warranty, 'file'>;

export type WarrantyUpdateFormRequest = Omit<Warranty, 'file'>;

export type DeleteWarrantyClaimAttachmentRequest = {
  warrantyClaimId?: number;
  attachmentId?: number;
};

export type AddWarrantyClaimAttachmentRequest = { warrantyClaimId?: number; formData: FormData };
export type AddWarrantyClaimAttachmentResponse = { attachmentId: number };

export type WarrantyUpdateStatusRequest = {
  newStatus: string;
  warrantyClaimId?: number;
};

export type WarrantyValidQuantityResponse = BaseApiResponse<{
  productNo: string;
  validQuantity: number;
  validPrice: number;
  productDisplayName: string;
}>;

export type WarrantyClaimNewClaimsCountResponse = BaseApiResponse<{
  newBeremaClaimsCount: number;
  newDealerClaimsCount: number;
}>;

export type BCProductsResponse = {
  productType: string;
  productModels: string[];
}[];
